import { useQuery } from '@tanstack/react-query'

/** Published by `scripts/build-apk.sh` in the vending-android repo, alongside
 *  the immutable APK it names. */
export interface ReleaseManifest {
  versionCode: number
  versionName: string
  /** Immutable per-build download URL, e.g. .../app-10.apk — never latest.apk,
   *  so the browser can name the saved file after the version instead of the
   *  path (t0617). */
  url: string
  sha256: string
  size: number
  notes?: string
}

export const MANIFEST_URL = 'https://portal.mevasertech.net/downloads/vending/manifest.json'

/** The latest published tablet build, for comparing against a device's own
 *  reported version. Shared by the Downloads page and the machine Devices
 *  tab so both read the one manifest fetch's cache. */
export function useReleaseManifest() {
  return useQuery({
    queryKey: ['vending', 'release-manifest'],
    queryFn: async () => {
      const res = await fetch(MANIFEST_URL, { cache: 'no-store' })
      if (!res.ok) throw new Error('No release published yet')
      return (await res.json()) as ReleaseManifest
    },
    retry: false,
  })
}
